import { useEffect, useState } from "react";

import {
  Button,
  CircularProgress,
  Grid,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { put } from "src/utils/networkUtils";

export default function PrizeDrawPrizeDialog(props) {
  const [prizeEntry, setPrizeEntry] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props?.prizeEntry) {
      setPrizeEntry(props.prizeEntry);
    }
  }, [props?.prizeEntry]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setPrizeEntry((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    put(
      `/admin/prize-draw-entries/${prizeEntry.prizeDrawEntryId}`,
      prizeEntry
    ).then(function (response) {
      setLoading(false);
      window.location.reload();
    });
  };
  const onCancel = () => {
    props.onClose();
  };

  const handleChangeCompleted = (e) => {
    setPrizeEntry((prevState) => ({
      ...prevState,
      isWinner: e.target.checked,
    }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Prize Draw Prize</DialogTitle>
      <DialogContent>
        {prizeEntry === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="prizeText"
                label="Prize"
                fullWidth
                value={prizeEntry.prizeText}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={prizeEntry.isWinner}
                    onChange={handleChangeCompleted}
                    id="isWinner"
                  />
                }
                label="Is Winner"
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button onClick={() => onSuccess()} autoFocus>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
